import z from "zod";
import { sizeFormSchema } from "../size";
import { weightFormSchema } from "../weight";

export const articleFormSchema = z
	.object({
		name: z.string(),
		articleProductTypeId: z.uuid(),
		description: z.string().nullish(),
		warningStockBalance: z.coerce.number().min(0),
		minimumStockBalance: z.coerce.number().min(0),
		/**
		 * Whether material of this article travels from the receiving zone to its shelf on a transfer
		 * carrier rather than being carried straight there.
		 *
		 * A property of the article rather than of the run that brings it back: what decides it is the
		 * thing's bulk and how it has to be handled, and that does not change between one return and
		 * the next.
		 */
		requiresTransferCarrierOnReturn: z.boolean().default(false),
		number: z.coerce.number().min(0).max(999),
		autoGenerateNumber: z.preprocess((val) => {
			if (!val) return false;
			return true;
		}, z.boolean()),
	})
	.and(sizeFormSchema)
	.and(weightFormSchema)
	.superRefine((values, context) => {
		if (values.warningStockBalance < values.minimumStockBalance) {
			context.addIssue({
				code: "custom",
				message: "Warning stock balance must be greater or equal to minimum stock balance",
				path: ["warningStockBalance"],
			});
		}
	});

export type ArticleFormSchema = z.infer<typeof articleFormSchema>;
